<template>
  <header>
    <nav class="container">
      <div class="branding">
        <router-link class="header" :to="{ name: 'Home' }"
          >مدونة الرؤي</router-link
        >
      </div>
      <div class="nav-links">
        <ul v-show="!mobile">
          <router-link class="link" :to="{ name: 'Home' }"
            >الصفحة الرئيسية</router-link
          >
          <router-link class="link" :to="{ name: 'Blogs' }"
            >المدونة</router-link
          >
          <router-link class="link" :to="{name: 'CreatePost'}" v-if="user">اكتب منشور</router-link>
          <router-link class="link" :to="{ name: 'Login' }" v-if="!user"
            >تسجيل الدخول</router-link
          >
        </ul>
        <div class="profile" ref="profile" v-if="user">
          <p @click="profileMenuToggle" class="init">{{
            this.$store.state.profileInitials
          }}</p>
          <div class="profile__menu" v-show="profileMenu">
            <span class="arrow"> </span>
            <div class="section1">
              <p class="intials">
                {{ this.$store.state.profileInitials }}
              </p>
              <div class="right">
                <p
                  >{{ this.$store.state.profileFirstName }}
                  {{ this.$store.state.profileLastName }}</p
                >
                <p>{{ this.$store.state.profileUsername }}</p>
                <p>{{ this.$store.state.profileEmail }}</p>
              </div>
            </div>
            <hr />
            <div class="options">
              <div class="option">
                <router-link class="option" :to="{ name: 'Profile' }">
                  <userIcon class="icon" />
                  <p>الملف</p>
                </router-link>
              </div>
              <div class="option">
                <router-link class="option" :to="{ name: 'Admin' }">
                  <adminIcon class="icon" />
                  <p>الأدمن</p>
                </router-link>
              </div>
              <div class="option" @click="signOut">
                <signOutIcon class="icon" />
                <p>تسجيل الخروج</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <menuIcon class="menu__icon" @click="toggleN" v-show="mobile" />
    <transition name="mobile-navo">
      <ul class="mobile-nav" v-show="mobileNav">
        <router-link class="link" :to="{ name: 'Home' }"
          >الصفحة الرئيسية</router-link
        >
        <router-link class="link" :to="{ name: 'Blogs' }">المدونة</router-link>
        <router-link class="link" :to="{name: 'CreatePost'}" v-if="user">اكتب منشور</router-link>
        <router-link class="link" :to="{ name: 'Login' }" v-if="!user"
          >تسجيل الدخول</router-link
        >
      </ul>
    </transition>
  </header>
</template>

<script>
import menuIcon from "../src/assets/Icons/bars-regular.svg";
import userIcon from "../src/assets/Icons/user-alt-light.svg";
import adminIcon from "../src/assets/Icons/user-crown-light.svg";
import signOutIcon from "../src/assets/Icons/sign-out-alt-regular.svg";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "NavB",
  components: {
    menuIcon,
    userIcon,
    adminIcon,
    signOutIcon,
  },
  data() {
    return {
      mobile: false,
      mobileNav: false,
      windowWidth: null,
      profileMenu: false,
    };
  },
  created() {
    window.addEventListener("resize", this.checkScreen());
    this.checkScreen();
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 750) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
      this.mobileNav = false;
      return;
    },
    toggleN() {
      this.mobileNav = !this.mobileNav;
    },
    profileMenuToggle() {
      this.profileMenu = !this.profileMenu;
    },
    signOut() {
      firebase.auth().signOut();
      window.location.reload();
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: #fff;
  padding: 0 25px;
  box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  .link {
    font-weight: 500;
    padding: 0 8px;
    transition: 0.3s color ease;
    &:hover {
      color: #1eb8b8;
    }
  }
  nav {
    display: flex;
    padding: 25px 0;
    .branding {
      display: flex;
      padding: 0px 10px 0px 0;

      .header {
        font-weight: 600;
        font-size: 34px;
        color: #000;
        text-decoration: none;
      }
    }
    .nav-links {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1;
      font-size: 19px;

      ul {
        margin-left: 32px;

        .link {
          margin-right: 32px;

          &:last-child {
            margin-left: 0;
          }
        }
      }
    }
  }

  .menu__icon {
    cursor: pointer;
    position: absolute;
    top: 39px;
    left: 25px;
    height: 25px;
    width: auto;
  }

  .mobile-nav {
    padding: 20px;
    width: 70%;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    position: fixed;
    height: 100%;
    background-color: #303030;
    top: 0;
    right: 0;
    z-index: 10;
    .link {
      padding: 15px 0;
      color: white;
      font-weight: 600;
      font-size: 19px;
    }
  }

  .mobile-navo-enter-active,
  .mobile-navo-leave-active {
    transition: all 500ms ease;
  }
  .mobile-navo-enter {
    transform: translateX(250px);
  }
  .mobile-navo-enter-to {
    transform: translateX(0);
  }
  .mobile-navo-leave-to {
    transform: translateX(250px);
  }

  .profile {
    font-size: 17px;
    .init {
      background-color: #303030;
      color: white;
      padding: 10px;
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 50%;
      text-transform: uppercase;
      cursor: pointer;
      font-size: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 750px) {
        position: relative;
        left: 40px;
        font-size: 23px;
      }
    }
    .arrow {
      position: absolute;
      left: 10px;
      top: -10px;
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      border-bottom: 10px solid #303030;
    }
    .profile__menu {
      display: flex;
      flex-direction: column;
      background-color: #303030;
      color: white;
      direction: ltr;
      min-width: 250px;
      word-break: break-all;
      height: auto;
      position: absolute;
      left: -2px;
      top: 70px;
      z-index: 9;
      @media (max-width: 750px) {
        left: 40px;
        min-width: 0;
        width: 270px;
      }
      .section1 {
        display: flex;
        align-items: center;
        padding: 20px;
        width: 100%;
      }
      .intials {
        background-color: white;
        color: #303030;
        padding: 10px;
        width: 80px;
        height: 80px;
        overflow: hidden;
        border-radius: 50%;
        text-transform: uppercase;
        font-size: 18px;
        word-break: keep-all;
        min-width: 47px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        @media (max-width: 750px) {
          font-size: 18px;
          padding: 10px;
        }
      }
      .right {
        padding-left: 30px;
      }
      .options {
        display: flex;
        flex-direction: column;
        margin: 18px;
        direction: rtl;
        .option {
          display: flex;
          justify-content: right;
          color: white;
          text-decoration: none;
          width: 100%;
          p {
            text-transform: capitalize;
            padding-right: 15px;
            cursor: pointer;
          }
        }
        .icon {
          width: 20px;
        }
      }
    }
  }
}

.option:nth-child(1),
.option:nth-child(2) {
  margin-bottom: 10px;
}
</style>
